import React from 'react'
import NavigationLogo from "./components/logo/logo"
import NavigationStructure from "../../core/model2/navigation/navigation-structure"
import Navigation_MyAccountBtn from "./buttons/my-account"
import ErrorBoundary from "../../core/error-boundary"
import NavigationSection from "../../core/model2/navigation/navigation-section"
import NavigationPanelReorderGroup from "./components/reorder-group/reorder-group"
import {UIType} from "../ui/@const";

type Props = {
    navigationStructure         : NavigationStructure
    onDragNavigationSectionsEnd : callback
    className?                  : string
}

// const debug = "NavigationCustomer"
const debug = false

export default function NavigationCustomer(props: Props) {

    debug && console.debug(debug, "Render()")

    const spaces = gd.spaces.navigationPanelTopSpacesAsNavigations

    const onReorder = (navigationSections: NavigationSection[]) => {
        debug && console.log(debug, "onReorder", navigationSections)

        gd.spaces.saveSpacesOrder(navigationSections)
    }

    const showLogo = gd.ui.type === UIType.TOP || gd.ui.type === UIType.LEFT || gd.ui.type === UIType.TEAMS
    const showMyAccount = gd.ui.type === UIType.TOP || gd.ui.type === UIType.LEFT || gd.ui.type === UIType.GOODDAY_MODERN

    return (
        <>
            <div className="top">
                <div className="top-container">
                    {showLogo && <NavigationLogo/>}

                    <ErrorBoundary>
                        <NavigationPanelReorderGroup sections   = {spaces}
                                                     onDragEnd  = {onReorder}/>
                    </ErrorBoundary>
                </div>
            </div>

            <div className="bottom">
                {showMyAccount && <Navigation_MyAccountBtn />}
            </div>
        </>
    )



}
